import React, { Fragment } from 'react';
import { FieldValidationErrors } from './field-validation-errors';
import { Label } from './label';
const Email = (props) => {
    const { field, value, onChange, tracker, errors } = props;
    return (React.createElement(Fragment, null,
        React.createElement(Label, Object.assign({}, props)),
        React.createElement("input", { type: "email", className: field.model.cssClass, id: field.valueField.id, name: field.valueField.name, value: value, maxLength: field.model.maxLength, placeholder: field.model.placeholderText, onChange: (e) => handleOnChange(field, e.target.value, onChange), onFocus: () => tracker.onFocusField(field, value), onBlur: () => tracker.onBlurField(field, value, errors) }),
        React.createElement(FieldValidationErrors, Object.assign({}, props))));
};
/**
 * @param {ValueFormField} field
 * @param {string} fieldValue
 * @param {FieldChangeCallback} callback
 */
function handleOnChange(field, fieldValue, callback) {
    let valid = true;
    const errorMessages = [];
    // custom client validation logic here
    if (field.model.required && !fieldValue) {
        valid = false;
        errorMessages.push(`${field.model.title} is required`);
    }
    callback(field.valueField.name, fieldValue, valid, errorMessages);
}
export default Email;
